import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  ADD_KIDS,
  GET_BALANCE_AVALABLE,
  KIDS_WALLET_PAYMENT_CONFIRM,
  WALLET_PAYMENT_REQUEST,
  WALLET_REQUEST,
  CASHFREE_PAYMENT_REQUEST,
  CASHFREE_CALLBACK_STATUS
} from "../../../redux/actions";
import {
  addKidsApi,
  getBalanceAvalableApi,
  kidsWalletPaymentConfirmApi,
  walletPaymentRequestApi,
  walletRequestApi,
} from "../../../routes/apiRoutes";
import axios from "axios";
import { cashFreePaymentRequestApi, cashFreeCallbackStatusApi} from './../../../routes/apiRoutes';

export const addKidsMiddleWare = createAsyncThunk(
  ADD_KIDS,
  async ({ payload }) => {
    try {
      const { data } = await axios.post(addKidsApi, payload);
      return data;
    } catch (error) {
      return error;
    }
  }
);

export const getBalanceAvalableMiddleWare = createAsyncThunk(
  GET_BALANCE_AVALABLE,
  async ({ id }) => {
    try {
      const { data } = await axios.get(getBalanceAvalableApi(id));
      return data;
    } catch (error) {
      return error;
    }
  }
);

export const kidsWalletPaymentConfirmMiddleWare = createAsyncThunk(
  KIDS_WALLET_PAYMENT_CONFIRM,
  async ({ payload }) => {
    try {
      const { data } = await axios.post(kidsWalletPaymentConfirmApi, payload);
      return data;
    } catch (error) {
      return error;
    }
  }
);

export const walletRequestMiddleWare = createAsyncThunk(
  WALLET_REQUEST,
  async ({ payload }) => {
    try {
      const { data } = await axios.post(walletRequestApi, payload);
      return data;
    } catch (error) {
      return error;
    }
  }
);

export const walletPaymentRequestMiddleWare = createAsyncThunk(
  WALLET_PAYMENT_REQUEST,
  async ({ payload }) => {
    try {
      const { data } = await axios.post(walletPaymentRequestApi, payload);
      return data;
    } catch (error) {
      return error;
    }
  }
);

export const cashFreePaymentRequestMiddleWare = createAsyncThunk(
  CASHFREE_PAYMENT_REQUEST,
  async ({ payload }) => {
    try {
      const { data } = await axios.post(cashFreePaymentRequestApi, payload);
      return data;
    } catch (error) {
      return error;
    }
  }
);

export const cashFreeCallbackStatusMiddleWare = createAsyncThunk(
  CASHFREE_CALLBACK_STATUS,
  async ({ payload }) => {
    const { data } = await axios.post(cashFreeCallbackStatusApi, payload);
    return data;
  }
);